import { AuthModel } from './auth.model';

export class UserModel extends AuthModel {
  id: string | null;
  name: string | null;
  email: string | null;
  username: string | null;
  fullName: string | null;
  password: string | null;
  roles: string | null;
  unitId: string | null;
  packageId: string | null;
  status: string | null;
  phoneNum: string | null;
  lastLoginAt: string | null;
  loginFailNum: number | null;
  gender: number |0;
  idNo: string | null;
  issuerDN: string | null;
  isLockLogin: boolean | null;
  lockReason: string | null;
  createdBy: string | null;
  createdTime: string | null;
  updatedBy: string | null;
  updatedTime: string | null;
  lockedTime: string | null;
  imageUrl: string | null;

  setUser(_user: unknown) {
    const user = _user as UserModel;
    this.id = user.id;
    this.name = user.name || '';
    this.email = user.email || '';
    this.username = user.username || '';
    this.password = user.password || '';
    this.roles = user.roles || '';
    this.unitId = user.unitId || '';
    this.packageId = user.packageId || '';
    this.status = user.status || '';
    this.phoneNum = user.phoneNum || '';
    this.gender = user.gender || 0;
    this.idNo = user.idNo || '';
    this.issuerDN = user.issuerDN || '';
    this.lastLoginAt = user.lastLoginAt || '';
    this.loginFailNum = user.loginFailNum || 0;
    this.isLockLogin = user.isLockLogin || null;
    this.lockReason = user.lockReason || '';
    this.createdBy = user.createdBy || '';
    this.createdTime = user.createdTime || '';
    this.updatedBy = user.updatedBy || '';
    this.updatedTime = user.updatedTime || '';
    this.lockedTime = user.lockedTime || '';
    this.imageUrl = user.imageUrl || './assets/media/users/default.jpg';
    this.fullName = user.fullName;
  }

  constructor() {
    super();
    this.id = null;
    this.name = null;
    this.email = null;
    this.username = null;
    this.password = null;
    this.roles = null;
    this.unitId = null;
    this.packageId = null;
    this.status = null;
    this.phoneNum = null;
    this.gender = 0;
    this.idNo = null;
    this.issuerDN = null;
    this.lastLoginAt = null;
    this.loginFailNum = null;
    this.isLockLogin = null;
    this.lockReason = null;
    this.createdBy = null;
    this.createdTime = null;
    this.updatedBy = null;
    this.updatedTime = null;
    this.lockedTime = null;
    this.imageUrl = null;
    this.fullName = null;
  }
}
